// import { LocationChangeAction } from 'connected-react-router';
// Should not be installed, as per doc https://reactrouter.com/docs/en/v6/routers/history-router
// import { createBrowserRouter } from 'react-router-dom';
// import { getBrowserRouter } from '#/components/AppEntry';
import { createBrowserHistory } from 'history';

import { trackPageView } from '#/lib/analytics';

// import { Reducer } from 'redux';
// import { createReduxHistoryContext, RouterState } from 'redux-first-history';

// Actions

// export type switchRouteAction = {
//   type: '@ROUTER TODO CHANGE';
// }; // LocationChangeAction<unknown>;

// Utils

// https://stackoverflow.com/questions/69871987/react-router-v6-navigate-outside-of-components
export const routerHistory = createBrowserHistory();

let lastPathname = '/';

routerHistory.listen(({ location, action: historyAction }) => {
  if (historyAction === 'REPLACE') {
    // Do not track instant redirects eg. /trading -> /trading/BTC-USD
    return;
  }
  const pathname = location?.pathname || '';

  if (
    // Accidental email record
    pathname.includes('@') ||
    // accidental address record
    pathname.includes('0x') ||
    pathname.includes('password') ||
    pathname.includes('bankroll')
  ) {
    return;
  }

  // const search = location?.search || '';
  if (lastPathname === pathname) {
    // Triggered multiple page-views for same screen
    return;
  }
  lastPathname = pathname;
  trackPageView(pathname);
});

// Reducer

// export const {
//   createReduxHistory,
//   routerMiddleware,
//   routerReducer,
// }: {
//   createReduxHistory: any;
//   routerMiddleware: any;
//   routerReducer: Reducer<RouterState<RouterCustomState>, LocationChangeAction>;
// } = createReduxHistoryContext({
//   history: routerHistory,
// });

// export const routerReducer = connectRouter(
//   routerHistory
//   // --- router typings fix
// ) as any as Reducer<RouterState<RouterCustomState>, LocationChangeAction>;
